import React from "react";
import {observer} from 'mobx-react';
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";


export const MiniOrbitSpinnerComponent = observer(class MiniOrbitSpinnerComponent extends OrbitComponent {

    /*private _calculateOffset = () => {
      let headerHeight = this.services.header.headerHeight;
      let headerArenasHeight = this.props.arenaHeaderHeightCalculator.headerArenasHeight;
      return headerHeight + headerArenasHeight;
    };*/

    render() {
        return <></>;
        // For now we remove the spinner from mini-orbit

        /*if(!this.services.spinner.isSpinning) {
            return null;
        }

        return (
            <MiniOrbitSpinnerBox offset={this._calculateOffset()} className={CyClass('cy-spinner')}>
                <SpinnerBrandBox className='cy-spinner-brand'>
                    <SpinnerBackgroundBox className='cy-spinner-background'/>
                    <SpinnerLogoBox className='cy-spinner-logo'/>
                </SpinnerBrandBox>
            </MiniOrbitSpinnerBox>
        );*/
    }
});
